import { createFileRoute, redirect } from "@tanstack/react-router";

/** Redirect old test URL to nested home route. */
export const Route = createFileRoute("/_app/diaries/$diaryId/progress")({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: "/diaries/$diaryId/home/results",
            params: { diaryId: params.diaryId },
        });
    },
});
